/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ShivaWebSecuredConfiguration } from '../shiva-web-secured-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { computePercentile } from '../fn/tag/compute-percentile';
import { ComputePercentile$Params } from '../fn/tag/compute-percentile';
import { deleteTags } from '../fn/tag/delete-tags';
import { DeleteTags$Params } from '../fn/tag/delete-tags';
import { searchStationTags } from '../fn/sites-management/search-station-tags';
import { searchStationTags$Any } from '../fn/sites-management/search-station-tags-any';
import { SearchStationTags$Any$Params } from '../fn/sites-management/search-station-tags-any';
import { SearchStationTags$Params } from '../fn/sites-management/search-station-tags';
import { searchTags } from '../fn/tag/search-tags';
import { searchTags$Any } from '../fn/tag/search-tags-any';
import { SearchTags$Any$Params } from '../fn/tag/search-tags-any';
import { SearchTags$Params } from '../fn/tag/search-tags';
import { TagList } from '../models/tag-list';
import { TagPercentile } from '../models/tag-percentile';
import { TagToDeleteRefused } from '../models/tag-to-delete-refused';
import { updateTagConfig } from '../fn/tag/update-tag-config';
import { UpdateTagConfig$Params } from '../fn/tag/update-tag-config';


/**
 * All about tag feature
 */
@Injectable({ providedIn: 'root' })
export class TagService extends BaseService {
  constructor(config: ShivaWebSecuredConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `updateTagConfig()` */
  static readonly UpdateTagConfigPath = '/tags/{uid}';

  /**
   * Update an existing tag configuration.
   *
   * Update an existing tag configuration
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateTagConfig()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateTagConfig$Response(params: UpdateTagConfig$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateTagConfig(this.http, this.rootUrl, params, context);
  }

  /**
   * Update an existing tag configuration.
   *
   * Update an existing tag configuration
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateTagConfig$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateTagConfig(params: UpdateTagConfig$Params, context?: HttpContext): Observable<void> {
    return this.updateTagConfig$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `deleteTags()` */
  static readonly DeleteTagsPath = '/tags/delete';

  /**
   * Add tags to the list of tags to delete.
   *
   * The tags
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteTags()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  deleteTags$Response(params: DeleteTags$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TagToDeleteRefused>>> {
    return deleteTags(this.http, this.rootUrl, params, context);
  }

  /**
   * Add tags to the list of tags to delete.
   *
   * The tags
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteTags$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  deleteTags(params: DeleteTags$Params, context?: HttpContext): Observable<Array<TagToDeleteRefused>> {
    return this.deleteTags$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<TagToDeleteRefused>>): Array<TagToDeleteRefused> => r.body)
    );
  }

  /** Path part for operation `searchTags()` */
  static readonly SearchTagsPath = '/tags/search';

  /**
   * Get the tags.
   *
   * The tags
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchTags()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchTags$Response(params?: SearchTags$Params, context?: HttpContext): Observable<StrictHttpResponse<TagList>> {
    return searchTags(this.http, this.rootUrl, params, context);
  }

  /**
   * Get the tags.
   *
   * The tags
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchTags$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchTags(params?: SearchTags$Params, context?: HttpContext): Observable<TagList> {
    return this.searchTags$Response(params, context).pipe(
      map((r: StrictHttpResponse<TagList>): TagList => r.body)
    );
  }

  /**
   * Get the tags.
   *
   * The tags
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchTags$Any()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  searchTags$Any$Response(params?: SearchTags$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<TagList>> {
    return searchTags$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * Get the tags.
   *
   * The tags
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchTags$Any$Response()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  searchTags$Any(params?: SearchTags$Any$Params, context?: HttpContext): Observable<TagList> {
    return this.searchTags$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<TagList>): TagList => r.body)
    );
  }

  /** Path part for operation `computePercentile()` */
  static readonly ComputePercentilePath = '/tags/{tagUid}/percentiles';

  /**
   * Compute percentile of a tag.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `computePercentile()` instead.
   *
   * This method doesn't expect any request body.
   */
  computePercentile$Response(params: ComputePercentile$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TagPercentile>>> {
    return computePercentile(this.http, this.rootUrl, params, context);
  }

  /**
   * Compute percentile of a tag.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `computePercentile$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  computePercentile(params: ComputePercentile$Params, context?: HttpContext): Observable<Array<TagPercentile>> {
    return this.computePercentile$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<TagPercentile>>): Array<TagPercentile> => r.body)
    );
  }

  /** Path part for operation `searchStationTags()` */
  static readonly SearchStationTagsPath = '/stations/{uid}/tags/search';

  /**
   * Get the tags for the station.
   *
   * The tags for the station
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchStationTags()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchStationTags$Response(params: SearchStationTags$Params, context?: HttpContext): Observable<StrictHttpResponse<TagList>> {
    return searchStationTags(this.http, this.rootUrl, params, context);
  }

  /**
   * Get the tags for the station.
   *
   * The tags for the station
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchStationTags$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchStationTags(params: SearchStationTags$Params, context?: HttpContext): Observable<TagList> {
    return this.searchStationTags$Response(params, context).pipe(
      map((r: StrictHttpResponse<TagList>): TagList => r.body)
    );
  }

  /**
   * Get the tags for the station.
   *
   * The tags for the station
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchStationTags$Any()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  searchStationTags$Any$Response(params: SearchStationTags$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<TagList>> {
    return searchStationTags$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * Get the tags for the station.
   *
   * The tags for the station
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchStationTags$Any$Response()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  searchStationTags$Any(params: SearchStationTags$Any$Params, context?: HttpContext): Observable<TagList> {
    return this.searchStationTags$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<TagList>): TagList => r.body)
    );
  }

}
